import {Injectable} from "@angular/core";
import {FormBuilder, FormGroup} from "@angular/forms";
import {DossierBaseModel} from "../dossierBaseModel";
import {ValidatorService} from "@amlCore/services";
import {IDossierSubService} from "../IDossierSub.service";
import {DossierAccessEnum} from "@amlCore/enums";

@Injectable()
export class SvedClientDossierService extends DossierBaseModel implements IDossierSubService {

  /**
   * Форма вкладки
   */
  form: FormGroup;

  constructor(protected formBuilder: FormBuilder, protected validationSrv: ValidatorService) {
    super(formBuilder, validationSrv);
  }


  /**
   * Инициализация формы
   * isNewForm - вернуть новую форму
   */
  getForm(isNewForm?: boolean, data?: any): FormGroup {
    if (!this.form || isNewForm) {
      this.newForm(data);
    }
    return this.form;
  }

  /**
   * Создание новой формы
   */
  newForm(data?: any): void {
    this.form = this.formBuilder.group({
      svedClient: this.getClientInfo(DossierAccessEnum.SVEDCLIENT, data?.svedClient)
    });
  }
}
